
// 用户
export class User {
    constructor(opt = {}) {
      this.reset(opt);
    }
    reset(opt = {}) {
      this.id = opt.id? opt.id:``;
      this.nickname = opt.nickname ?? ``;             
      this.username = opt.username ?? ``;         
      this.email = opt.email ?? ``;     
      this.avatar = opt.avatar?? ``; 
      this.company = opt.company?? ``;     
      this.createTime = opt.createTime?? ``;   
      this.bindWeiChat = opt.bindWeiChat?? true;
    }
}

// ai-title
export class AiTitle {
  constructor(opt = {}) {
    this.reset(opt);
  }
  reset(opt = {}) {
    this.id = opt.id? opt.id:``;
    this.title = opt.title ?? ``;             
    this.keyword = opt.keyword ?? ``;         
    this.state = opt.state ?? 0;     
    this.tag = opt.tag?? ``;   
    this.createTime = opt.createTime?? ``;   
  }
}

// ai-title
export class AiArticle {
  constructor(opt = {}) {
    this.reset(opt);
  }
  reset(opt = {}) {
    this.id = opt.id? opt.id:``;
    this.title = opt.title ?? ``;             
    this.keyword = opt.keyword ?? ``;         
    this.state = opt.state ?? 0;     
    this.tag = opt.tag?? ``;   
    this.createTime = opt.createTime?? ``;   
    this.atsId = opt.atsId?? ``;
    this.content = opt.content?? ``;
  }
}

export class AiPlatform1 {
  constructor(opt = {}) {
    this.reset(opt);
  }
  reset(opt = {}) {
    this.appid = opt.appid? opt.appid:``;
    this.appsecret = opt.appsecret ?? ``;             
    this.catid = opt.catid ?? ``;         
    this.thumb = opt.thumb ?? ``;     
    this.module = opt.module?? ``;   
    this.username = opt.username?? ``;   
    this.password = opt.password?? ``;
  }
}

export class AiPlatform2 {
  constructor(opt = {}) {
    this.reset(opt);
  }
  reset(opt = {}) {
    this.domain = opt.domain? opt.domain:``;
    this.name = opt.name ?? ``;             
    this.count = opt.count ?? 1;         
    this.publishTime = opt.publishTime ?? ``;   
    this.state = opt.state ?? 1;
  }
}




// WEBPACK FOOTER //
// ./src/module/entity.js